<template>
  <n-layout class="layout">
    <n-layout-header class="header">
      <div class="fold">
        <Icon size="40" :color="foldColor" @click="foldClick">
          <TextAlignJustify></TextAlignJustify>
        </Icon>
      </div>
      <img src="../assets/yestool.png" class="codetool" @click="itemClick('/')" />
    </n-layout-header>
    <n-layout has-sider>
      <n-layout-sider collapse-mode="width" :collapsed="collapsed" :collapsed-width="50" :width="240">
        <n-menu v-model:value="currentMenuValue" :options="menus"></n-menu>
      </n-layout-sider>
      <n-layout-content>
        <router-view></router-view>
      </n-layout-content>
    </n-layout>
    <!-- <router-view> </router-view> -->
    <n-layout-footer class="footer" position="absolute">
      <a href="http://beian.miit.gov.cn" target="_blank" class="beian">{{ webcode }}</a>
    </n-layout-footer>
  </n-layout>
</template>
<script setup>
import { getCurrentInstance, onMounted, ref, h } from "vue"
import { Icon } from "@vicons/utils"
import { NIcon } from "naive-ui"
import { RouterLink } from "vue-router"
import { Json, Xml, ToolKit, Blockchain, StringText, QrCode, Cube, TextAlignJustify, Api1 } from "@vicons/carbon"
import { useRoute } from "vue-router"

// 全局对象
const app = getCurrentInstance().appContext.config.globalProperties.app
const webcode = app.webcode
// 点击跳转路由
const itemClick = (route) => {
  router.push(route)
}

const collapsed = ref(true)

// 选中颜色
const selectedColor = "#FF6600"
// 默认颜色
const defaultColor = "#009966"
// 当前颜色
const foldColor = ref(defaultColor)

const foldClick = () => {
  if (foldColor.value == selectedColor) {
    foldColor.value = defaultColor
    collapsed.value = true
  } else {
    foldColor.value = selectedColor
    collapsed.value = false
  }
}

// 路由
const router = useRoute()

// 渲染图标
function renderIcon(icon, color, size) {
  return () => h(NIcon, { color: color, size: size }, { default: () => h(icon) })
}
// 渲染显示文字
function renderLabel(text, route) {
  return () => h(RouterLink, { to: { path: route } }, { default: () => text })
}

const menus = [
  {
    label: "json",
    key: "json",
    icon: renderIcon(Json, "green"),
    children: [
      {
        label: renderLabel("json格式化", "/home/jsonformat"),
        key: "json-format",
        icon: renderIcon(Cube, "#40de5a", 16),
      },
      {
        label: renderLabel("json转实体", "/home/jsonmodel"),
        key: "json-model",
        icon: renderIcon(Cube, "#00bc12", 16),
      },
      {
        label: renderLabel("json转xml", "/home/jsonxml"),
        key: "json-xml",
        icon: renderIcon(Cube, "#2add9c", 16),
      },
    ],
  },
  {
    label: "xml",
    key: "xml",
    icon: renderIcon(Xml, "#fa8c35"),
    children: [
      {
        label: renderLabel("xml格式化", "/home/xmlformat"),
        key: "xml-format",
        icon: renderIcon(Cube, "#ffa631", 16),
      },
      {
        label: renderLabel("xml转实体", "/home/xmlmodel"),
        key: "xml-model",
        icon: renderIcon(Cube, "#ffa400", 16),
      },
      {
        label: renderLabel("xml转json", "/home/xmljson"),
        key: "xml-json",
        icon: renderIcon(Cube, "#ffa400", 16),
      },
    ],
  },
  {
    label: "正则表达式",
    key: "regular",
    icon: renderIcon(Blockchain, "blue"),
    children: [
      {
        label: renderLabel("正则表达式", "/home/expression"),
        key: "regular",
        icon: renderIcon(Cube, "#177cb0", 16),
      },
    ],
  },
  {
    label: "字符串",
    key: "crypto",
    icon: renderIcon(StringText, "#8d4bbb"),
    children: [
      {
        label: renderLabel("MD5、SHA加密", "/home/md5sha"),
        key: "md5sha",
        icon: renderIcon(Cube, "#815463", 16),
      },
      {
        label: renderLabel("生成GUID", "/home/generateguid"),
        key: "generateguid",
        icon: renderIcon(Cube, "#0099CC", 16),
      },
      {
        label: renderLabel("字符串计算", "/home/stringcalc"),
        key: "stringcalc",
        icon: renderIcon(Cube, "#CC9933", 16),
      },
    ],
  },
  {
    label: "二维码",
    key: "qrcode",
    icon: renderIcon(QrCode, "#726930"),
    children: [
      {
        label: renderLabel("二维码", "/home/qrcode"),
        key: "qrcode-create",
        icon: renderIcon(Cube, "#525f42", 16),
      },
    ],
  },
  {
    label: "工具",
    key: "util",
    icon: renderIcon(ToolKit, "#009999"),
    children: [
      {
        label: renderLabel("API", "/home/api"),
        key: "util-api",
        icon: renderIcon(Api1, "#FF9966", 16),
      },
      {
        label: renderLabel("ASCII艺术字", "/home/wordart"),
        key: "util-ascii-wordart",
        icon: renderIcon(Cube, "#9933FF", 16),
      },
      {
        label: renderLabel("常用颜色", "/home/colors"),
        key: "util-colors",
        icon: renderIcon(Cube, "#66CC99", 16),
      },
    ],
  },
]

//判断默认选择的菜单
let currentPath = router.path
let selectMenu = "json-format"
menus.forEach((menu) => {
  menu.children.forEach((item) => {
    if (currentPath == item.label().props.to.path) {
      selectMenu = item.key
    }
  })
})
// 当前菜单
const currentMenuValue = ref(selectMenu)
</script>
<style scoped>
.layout {
  height: 100vh;
}
.header {
  background-color: white;
  height: 5vh;
}
.header .codetool {
  height: 5vh;
  margin-left: 10px;
}
.content-left {
  height: 92vh;
}
.content-center {
  height: 92vh;
}
.footer {
  line-height: 3vh;
  text-align: center;
  background-color: white;
}
.beian {
  color: black;
  text-decoration: none;
}
.fold {
  display: inline-block;
  padding-left: 4px;
}
</style>
